import { DateTime } from 'luxon';
import type { QuoteSessionType, Schedule } from '@benzinga/quotes-manager';

/**
 * Session that contains `now`.
 *
 * Windows are half-open [start, end) so abutting sessions (pre-market ending at
 * 9:30, regular starting at 9:30) don't leave a gap where this returns null.
 * A null result means the schedule is missing or `now` sits in no session —
 * callers must not invent a session from a stale `schedule.type`.
 */
export const getCurrentSessionType = (schedule?: Schedule, now: DateTime = DateTime.now()): QuoteSessionType | null => {
  if (!schedule?.sessions?.length) return null;

  const currentMs = now.toMillis();
  const activeSession = schedule.sessions.find(
    session => currentMs >= session.startTime && currentMs < session.endTime,
  );

  return activeSession?.type ?? null;
};
